import { HttpClient, MiniSocApi, SessionStore } from '@minisoc/api-client';

export const API_URL = import.meta.env.VITE_API_URL ?? 'http://localhost:3000/api/v1';
export const WS_URL = import.meta.env.VITE_WS_URL ?? 'http://localhost:3000';

/**
 * Espace de nommage distinct du backoffice : les deux applications tournent sur
 * `localhost` en développement et partageraient sinon le même `localStorage`,
 * une connexion écrasant l'autre.
 */
export const sessionStore = new SessionStore('dashboard');

const http = new HttpClient({
  baseUrl: API_URL,
  session: sessionStore,
  onSessionExpired: () => {
    // Rechargement complet plutôt qu'une navigation React : cela vide aussi le
    // cache React Query, qui contiendrait sinon les données de la session perdue.
    window.location.reload();
  },
});

export const api = new MiniSocApi(http);
